// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { ActivateLocationProfilePlanesLocationProfilesProfileIdActivePutData, ActivateLocationProfilePlanesLocationProfilesProfileIdActivePutErrors, ActivateLocationProfilePlanesLocationProfilesProfileIdActivePutResponses, AddCustomDeviceMqttCustomDevicesPostData, AddCustomDeviceMqttCustomDevicesPostErrors, AddCustomDeviceMqttCustomDevicesPostResponses, AddEventNotificationsPostData, AddEventNotificationsPostErrors, AddEventNotificationsPostResponses, AddLocationProfilePlanesLocationProfilesPostData, AddLocationProfilePlanesLocationProfilesPostErrors, AddLocationProfilePlanesLocationProfilesPostResponses, AddScheduleKasaSchedulePostData, AddScheduleKasaSchedulePostErrors, AddScheduleKasaSchedulePostResponses, AddWatchlistEntryPlanesWatchlistPostData, AddWatchlistEntryPlanesWatchlistPostErrors, AddWatchlistEntryPlanesWatchlistPostResponses, AllSensorsSensorsAllGetData, AllSensorsSensorsAllGetResponses, AutoBrightnessAutoGetData, AutoBrightnessAutoGetResponses, AutoBrightnessAutoPostData, AutoBrightnessAutoPostResponses, BrightnessKasaBrightnessPostData, BrightnessKasaBrightnessPostErrors, BrightnessKasaBrightnessPostResponses, ClearMonthlyOverrideMoneyBudgetOverrideMonthDeleteData, ClearMonthlyOverrideMoneyBudgetOverrideMonthDeleteErrors, ClearMonthlyOverrideMoneyBudgetOverrideMonthDeleteResponses, ConfigSubscribeConfigSubscribeGetData, ConfigSubscribeConfigSubscribeGetResponses, CountdownKasaCountdownPostData, CountdownKasaCountdownPostErrors, CountdownKasaCountdownPostResponses, DeleteEventNotificationsEventIdDeleteData, DeleteEventNotificationsEventIdDeleteErrors, DeleteEventNotificationsEventIdDeleteResponses, DeleteLocationProfilePlanesLocationProfilesProfileIdDeleteData, DeleteLocationProfilePlanesLocationProfilesProfileIdDeleteErrors, DeleteLocationProfilePlanesLocationProfilesProfileIdDeleteResponses, DeleteModelVoiceModelsModelIdDeleteData, DeleteModelVoiceModelsModelIdDeleteErrors, DeleteModelVoiceModelsModelIdDeleteResponses, DeletePreferenceNotificationsPreferencesEventTypeDeleteData, DeletePreferenceNotificationsPreferencesEventTypeDeleteErrors, DeletePreferenceNotificationsPreferencesEventTypeDeleteResponses, DeleteScheduleKasaScheduleDeleteData, DeleteScheduleKasaScheduleDeleteErrors, DeleteScheduleKasaScheduleDeleteResponses, DeleteVoiceVoiceTtsVoicesVoiceIdDeleteData, DeleteVoiceVoiceTtsVoicesVoiceIdDeleteErrors, DeleteVoiceVoiceTtsVoicesVoiceIdDeleteResponses, DeleteWatchlistEntryPlanesWatchlistEntryIdDeleteData, DeleteWatchlistEntryPlanesWatchlistEntryIdDeleteErrors, DeleteWatchlistEntryPlanesWatchlistEntryIdDeleteResponses, DevicesSensorsDevicesGetData, DevicesSensorsDevicesGetResponses, DiscoverKasaDiscoverGetData, DiscoverKasaDiscoverGetResponses, DiscoverKasaDiscoverPostData, DiscoverKasaDiscoverPostResponses, DismissEventNotificationsEventIdDismissPostData, DismissEventNotificationsEventIdDismissPostErrors, DismissEventNotificationsEventIdDismissPostResponses, DownloadModelVoiceModelsModelIdDownloadPostData, DownloadModelVoiceModelsModelIdDownloadPostErrors, DownloadModelVoiceModelsModelIdDownloadPostResponses, DownloadVoiceVoiceTtsVoicesVoiceIdDownloadPostData, DownloadVoiceVoiceTtsVoicesVoiceIdDownloadPostErrors, DownloadVoiceVoiceTtsVoicesVoiceIdDownloadPostResponses, GetBridgeInfoMqttBridgeGetData, GetBridgeInfoMqttBridgeGetResponses, GetBrightnessConfigConfigBrightnessGetData, GetBrightnessConfigConfigBrightnessGetResponses, GetConfigConfigGetData, GetConfigConfigGetResponses, GetDueNotificationsDueGetData, GetDueNotificationsDueGetResponses, GetModelVoiceModelsModelIdGetData, GetModelVoiceModelsModelIdGetErrors, GetModelVoiceModelsModelIdGetResponses, GetPreferencesNotificationsPreferencesGetData, GetPreferencesNotificationsPreferencesGetResponses, GetSettingsMoneySettingsGetData, GetSettingsMoneySettingsGetResponses, GetSettingsPlanesSettingsGetData, GetSettingsPlanesSettingsGetResponses, GetStatusAdguardStatusPostData, GetStatusAdguardStatusPostErrors, GetStatusAdguardStatusPostResponses, GetSummaryMoneySummaryGetData, GetSummaryMoneySummaryGetErrors, GetSummaryMoneySummaryGetResponses, GetSystemStatsSystemStatsGetData, GetSystemStatsSystemStatsGetResponses, GetTransactionsMoneyTransactionsGetData, GetTransactionsMoneyTransactionsGetResponses, GetVersionAdguardVersionPostData, GetVersionAdguardVersionPostErrors, GetVersionAdguardVersionPostResponses, GetVoiceVoiceTtsVoicesVoiceIdGetData, GetVoiceVoiceTtsVoicesVoiceIdGetErrors, GetVoiceVoiceTtsVoicesVoiceIdGetResponses, HealthHealthGetData, HealthHealthGetResponses, IndoorSensorsIndoorGetData, IndoorSensorsIndoorGetResponses, LinkAccountsMoneyLinkPostData, LinkAccountsMoneyLinkPostErrors, LinkAccountsMoneyLinkPostResponses, ListCustomDevicesMqttCustomDevicesGetData, ListCustomDevicesMqttCustomDevicesGetResponses, ListDevicesMqttDevicesGetData, ListDevicesMqttDevicesGetResponses, ListEventsNotificationsGetData, ListEventsNotificationsGetResponses, ListLocationProfilesPlanesLocationProfilesGetData, ListLocationProfilesPlanesLocationProfilesGetResponses, ListModelsVoiceModelsGetData, ListModelsVoiceModelsGetResponses, ListVoicesVoiceTtsVoicesGetData, ListVoicesVoiceTtsVoicesGetResponses, ListWatchlistPlanesWatchlistGetData, ListWatchlistPlanesWatchlistGetResponses, LivePlanesLiveGetData, LivePlanesLiveGetResponses, LookupMacWolMacGetData, LookupMacWolMacGetErrors, LookupMacWolMacGetResponses, OutdoorSensorsOutdoorGetData, OutdoorSensorsOutdoorGetResponses, PingWolPingGetData, PingWolPingGetErrors, PingWolPingGetResponses, RemoveCustomDeviceMqttCustomDevicesRemovePostData, RemoveCustomDeviceMqttCustomDevicesRemovePostErrors, RemoveCustomDeviceMqttCustomDevicesRemovePostResponses, RemoveDeviceMqttDevicesRemovePostData, RemoveDeviceMqttDevicesRemovePostErrors, RemoveDeviceMqttDevicesRemovePostResponses, RenameDeviceMqttDevicesRenamePostData, RenameDeviceMqttDevicesRenamePostErrors, RenameDeviceMqttDevicesRenamePostResponses, RootGetData, RootGetResponses, ScheduleKasaScheduleGetData, ScheduleKasaScheduleGetErrors, ScheduleKasaScheduleGetResponses, SendCommandVoiceCommandPostData, SendCommandVoiceCommandPostErrors, SendCommandVoiceCommandPostResponses, SetBrightnessBrightnessSetPostData, SetBrightnessBrightnessSetPostErrors, SetBrightnessBrightnessSetPostResponses, SetConfigConfigPostData, SetConfigConfigPostErrors, SetConfigConfigPostResponses, SetDefaultBudgetMoneyBudgetPostData, SetDefaultBudgetMoneyBudgetPostErrors, SetDefaultBudgetMoneyBudgetPostResponses, SetDepositSettingsMoneySettingsDepositsPostData, SetDepositSettingsMoneySettingsDepositsPostErrors, SetDepositSettingsMoneySettingsDepositsPostResponses, SetMonthlyOverrideMoneyBudgetOverridePostData, SetMonthlyOverrideMoneyBudgetOverridePostErrors, SetMonthlyOverrideMoneyBudgetOverridePostResponses, SetPermitJoinMqttPermitJoinPostData, SetPermitJoinMqttPermitJoinPostErrors, SetPermitJoinMqttPermitJoinPostResponses, SetPreferenceNotificationsPreferencesEventTypePostData, SetPreferenceNotificationsPreferencesEventTypePostErrors, SetPreferenceNotificationsPreferencesEventTypePostResponses, SetProtectionAdguardProtectionPostData, SetProtectionAdguardProtectionPostErrors, SetProtectionAdguardProtectionPostResponses, SetTransactionExcludedMoneyTransactionsTransactionIdExcludePostData, SetTransactionExcludedMoneyTransactionsTransactionIdExcludePostErrors, SetTransactionExcludedMoneyTransactionsTransactionIdExcludePostResponses, SetTransferKeywordsMoneySettingsTransfersPostData, SetTransferKeywordsMoneySettingsTransfersPostErrors, SetTransferKeywordsMoneySettingsTransfersPostResponses, SpeakEndpointVoiceTtsSpeakPostData, SpeakEndpointVoiceTtsSpeakPostErrors, SpeakEndpointVoiceTtsSpeakPostResponses, StatusBrightnessStatusGetData, StatusBrightnessStatusGetResponses, StatusKasaStatusGetData, StatusKasaStatusGetErrors, StatusKasaStatusGetResponses, StatusSensorsStatusGetData, StatusSensorsStatusGetResponses, SubscribeVoiceSubscribeGetData, SubscribeVoiceSubscribeGetResponses, SunBrightnessSunGetData, SunBrightnessSunGetResponses, SyncNowMoneySyncPostData, SyncNowMoneySyncPostResponses, ToggleByNameKasaToggleByNamePostData, ToggleByNameKasaToggleByNamePostErrors, ToggleByNameKasaToggleByNamePostResponses, ToggleKasaTogglePostData, ToggleKasaTogglePostErrors, ToggleKasaTogglePostResponses, TranscribeAndExecuteVoiceTranscribeAndExecutePostData, TranscribeAndExecuteVoiceTranscribeAndExecutePostResponses, TranscribeVoiceTranscribePostData, TranscribeVoiceTranscribePostResponses, TriggerCheckNotificationsCheckPostData, TriggerCheckNotificationsCheckPostResponses, TtsStatusVoiceTtsStatusGetData, TtsStatusVoiceTtsStatusGetResponses, UndismissEventNotificationsEventIdUndismissPostData, UndismissEventNotificationsEventIdUndismissPostErrors, UndismissEventNotificationsEventIdUndismissPostResponses, UnlinkMoneyLinkDeleteData, UnlinkMoneyLinkDeleteResponses, UpdateLocationProfilePlanesLocationProfilesProfileIdPutData, UpdateLocationProfilePlanesLocationProfilesProfileIdPutErrors, UpdateLocationProfilePlanesLocationProfilesProfileIdPutResponses, UpdateScheduleKasaSchedulePutData, UpdateScheduleKasaSchedulePutErrors, UpdateScheduleKasaSchedulePutResponses, UpdateSettingsPlanesSettingsPutData, UpdateSettingsPlanesSettingsPutErrors, UpdateSettingsPlanesSettingsPutResponses, UpdateWatchlistEntryPlanesWatchlistEntryIdPutData, UpdateWatchlistEntryPlanesWatchlistEntryIdPutErrors, UpdateWatchlistEntryPlanesWatchlistEntryIdPutResponses, VolumeGetVolumeGetData, VolumeGetVolumeGetResponses, VolumeSetVolumePostData, VolumeSetVolumePostErrors, VolumeSetVolumePostResponses, WakeWolWakePostData, WakeWolWakePostErrors, WakeWolWakePostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Root
 */
export const rootGet = <ThrowOnError extends boolean = false>(options?: Options<RootGetData, ThrowOnError>): RequestResult<RootGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RootGetResponses, unknown, ThrowOnError>({ url: '/', ...options });

/**
 * Health
 *
 * Health check endpoint.
 */
export const healthHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthHealthGetData, ThrowOnError>): RequestResult<HealthHealthGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthHealthGetResponses, unknown, ThrowOnError>({ url: '/health', ...options });

/**
 * Config Subscribe
 *
 * SSE endpoint for live config updates.
 */
export const configSubscribeConfigSubscribeGet = <ThrowOnError extends boolean = false>(options?: Options<ConfigSubscribeConfigSubscribeGetData, ThrowOnError>): RequestResult<ConfigSubscribeConfigSubscribeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConfigSubscribeConfigSubscribeGetResponses, unknown, ThrowOnError>({ url: '/config/subscribe', ...options });

/**
 * Get Config
 *
 * Get full dashboard configuration.
 */
export const getConfigConfigGet = <ThrowOnError extends boolean = false>(options?: Options<GetConfigConfigGetData, ThrowOnError>): RequestResult<GetConfigConfigGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetConfigConfigGetResponses, unknown, ThrowOnError>({ url: '/config', ...options });

/**
 * Set Config
 *
 * Save dashboard configuration.
 *
 * Note: If data contains _saveId, it will be:
 * 1. Stripped before persisting to file
 * 2. Echoed in the SSE notification so the originating client
 * can ignore the update it triggered
 */
export const setConfigConfigPost = <ThrowOnError extends boolean = false>(options: Options<SetConfigConfigPostData, ThrowOnError>): RequestResult<SetConfigConfigPostResponses, SetConfigConfigPostErrors, ThrowOnError> => (options.client ?? client).post<SetConfigConfigPostResponses, SetConfigConfigPostErrors, ThrowOnError>({
    url: '/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Brightness Config
 *
 * Get just the brightness section (for shell script).
 */
export const getBrightnessConfigConfigBrightnessGet = <ThrowOnError extends boolean = false>(options?: Options<GetBrightnessConfigConfigBrightnessGetData, ThrowOnError>): RequestResult<GetBrightnessConfigConfigBrightnessGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBrightnessConfigConfigBrightnessGetResponses, unknown, ThrowOnError>({ url: '/config/brightness', ...options });

/**
 * Volume Get
 *
 * Get current volume level.
 */
export const volumeGetVolumeGet = <ThrowOnError extends boolean = false>(options?: Options<VolumeGetVolumeGetData, ThrowOnError>): RequestResult<VolumeGetVolumeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<VolumeGetVolumeGetResponses, unknown, ThrowOnError>({ url: '/volume', ...options });

/**
 * Volume Set
 *
 * Set volume level.
 */
export const volumeSetVolumePost = <ThrowOnError extends boolean = false>(options: Options<VolumeSetVolumePostData, ThrowOnError>): RequestResult<VolumeSetVolumePostResponses, VolumeSetVolumePostErrors, ThrowOnError> => (options.client ?? client).post<VolumeSetVolumePostResponses, VolumeSetVolumePostErrors, ThrowOnError>({
    url: '/volume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Wake
 *
 * Send Wake-on-LAN magic packet.
 */
export const wakeWolWakePost = <ThrowOnError extends boolean = false>(options: Options<WakeWolWakePostData, ThrowOnError>): RequestResult<WakeWolWakePostResponses, WakeWolWakePostErrors, ThrowOnError> => (options.client ?? client).post<WakeWolWakePostResponses, WakeWolWakePostErrors, ThrowOnError>({
    url: '/wol/wake',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ping
 *
 * Check if a host is online via ping.
 */
export const pingWolPingGet = <ThrowOnError extends boolean = false>(options: Options<PingWolPingGetData, ThrowOnError>): RequestResult<PingWolPingGetResponses, PingWolPingGetErrors, ThrowOnError> => (options.client ?? client).get<PingWolPingGetResponses, PingWolPingGetErrors, ThrowOnError>({ url: '/wol/ping', ...options });

/**
 * Lookup Mac
 *
 * Get MAC address for an IP/hostname via ARP table (device must be on same network).
 */
export const lookupMacWolMacGet = <ThrowOnError extends boolean = false>(options: Options<LookupMacWolMacGetData, ThrowOnError>): RequestResult<LookupMacWolMacGetResponses, LookupMacWolMacGetErrors, ThrowOnError> => (options.client ?? client).get<LookupMacWolMacGetResponses, LookupMacWolMacGetErrors, ThrowOnError>({ url: '/wol/mac', ...options });

/**
 * Sun
 *
 * Get today's sunrise/sunset times (cached daily).
 */
export const sunBrightnessSunGet = <ThrowOnError extends boolean = false>(options?: Options<SunBrightnessSunGetData, ThrowOnError>): RequestResult<SunBrightnessSunGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SunBrightnessSunGetResponses, unknown, ThrowOnError>({ url: '/brightness/sun', ...options });

/**
 * Set Brightness
 *
 * Manually set brightness level.
 */
export const setBrightnessBrightnessSetPost = <ThrowOnError extends boolean = false>(options: Options<SetBrightnessBrightnessSetPostData, ThrowOnError>): RequestResult<SetBrightnessBrightnessSetPostResponses, SetBrightnessBrightnessSetPostErrors, ThrowOnError> => (options.client ?? client).post<SetBrightnessBrightnessSetPostResponses, SetBrightnessBrightnessSetPostErrors, ThrowOnError>({
    url: '/brightness/set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Status
 *
 * Get current brightness and sun times.
 */
export const statusBrightnessStatusGet = <ThrowOnError extends boolean = false>(options?: Options<StatusBrightnessStatusGetData, ThrowOnError>): RequestResult<StatusBrightnessStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StatusBrightnessStatusGetResponses, unknown, ThrowOnError>({ url: '/brightness/status', ...options });

/**
 * Auto
 *
 * Auto-adjust brightness based on sun position. Call from cron.
 */
export const autoBrightnessAutoGet = <ThrowOnError extends boolean = false>(options?: Options<AutoBrightnessAutoGetData, ThrowOnError>): RequestResult<AutoBrightnessAutoGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AutoBrightnessAutoGetResponses, unknown, ThrowOnError>({ url: '/brightness/auto', ...options });

/**
 * Auto
 *
 * Auto-adjust brightness based on sun position. Call from cron.
 */
export const autoBrightnessAutoPost = <ThrowOnError extends boolean = false>(options?: Options<AutoBrightnessAutoPostData, ThrowOnError>): RequestResult<AutoBrightnessAutoPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AutoBrightnessAutoPostResponses, unknown, ThrowOnError>({ url: '/brightness/auto', ...options });

/**
 * Status
 *
 * Get MQTT connection status.
 */
export const statusSensorsStatusGet = <ThrowOnError extends boolean = false>(options?: Options<StatusSensorsStatusGetData, ThrowOnError>): RequestResult<StatusSensorsStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StatusSensorsStatusGetResponses, unknown, ThrowOnError>({ url: '/sensors/status', ...options });

/**
 * Devices
 *
 * List available climate sensors (Zigbee2MQTT + custom).
 */
export const devicesSensorsDevicesGet = <ThrowOnError extends boolean = false>(options?: Options<DevicesSensorsDevicesGetData, ThrowOnError>): RequestResult<DevicesSensorsDevicesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DevicesSensorsDevicesGetResponses, unknown, ThrowOnError>({ url: '/sensors/devices', ...options });

/**
 * Indoor
 *
 * Get indoor sensor reading.
 */
export const indoorSensorsIndoorGet = <ThrowOnError extends boolean = false>(options?: Options<IndoorSensorsIndoorGetData, ThrowOnError>): RequestResult<IndoorSensorsIndoorGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<IndoorSensorsIndoorGetResponses, unknown, ThrowOnError>({ url: '/sensors/indoor', ...options });

/**
 * Outdoor
 *
 * Get outdoor sensor reading.
 */
export const outdoorSensorsOutdoorGet = <ThrowOnError extends boolean = false>(options?: Options<OutdoorSensorsOutdoorGetData, ThrowOnError>): RequestResult<OutdoorSensorsOutdoorGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OutdoorSensorsOutdoorGetResponses, unknown, ThrowOnError>({ url: '/sensors/outdoor', ...options });

/**
 * All Sensors
 *
 * Get all sensor readings with comparison.
 */
export const allSensorsSensorsAllGet = <ThrowOnError extends boolean = false>(options?: Options<AllSensorsSensorsAllGetData, ThrowOnError>): RequestResult<AllSensorsSensorsAllGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AllSensorsSensorsAllGetResponses, unknown, ThrowOnError>({ url: '/sensors/all', ...options });

/**
 * Discover
 *
 * Discover Kasa devices on the network with extended info.
 */
export const discoverKasaDiscoverGet = <ThrowOnError extends boolean = false>(options?: Options<DiscoverKasaDiscoverGetData, ThrowOnError>): RequestResult<DiscoverKasaDiscoverGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DiscoverKasaDiscoverGetResponses, unknown, ThrowOnError>({ url: '/kasa/discover', ...options });

/**
 * Discover
 *
 * Discover Kasa devices on the network with extended info.
 */
export const discoverKasaDiscoverPost = <ThrowOnError extends boolean = false>(options?: Options<DiscoverKasaDiscoverPostData, ThrowOnError>): RequestResult<DiscoverKasaDiscoverPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<DiscoverKasaDiscoverPostResponses, unknown, ThrowOnError>({ url: '/kasa/discover', ...options });

/**
 * Toggle
 *
 * Toggle a Kasa device on/off.
 */
export const toggleKasaTogglePost = <ThrowOnError extends boolean = false>(options: Options<ToggleKasaTogglePostData, ThrowOnError>): RequestResult<ToggleKasaTogglePostResponses, ToggleKasaTogglePostErrors, ThrowOnError> => (options.client ?? client).post<ToggleKasaTogglePostResponses, ToggleKasaTogglePostErrors, ThrowOnError>({
    url: '/kasa/toggle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Toggle By Name
 *
 * Toggle a Kasa device by name (for voice commands).
 */
export const toggleByNameKasaToggleByNamePost = <ThrowOnError extends boolean = false>(options: Options<ToggleByNameKasaToggleByNamePostData, ThrowOnError>): RequestResult<ToggleByNameKasaToggleByNamePostResponses, ToggleByNameKasaToggleByNamePostErrors, ThrowOnError> => (options.client ?? client).post<ToggleByNameKasaToggleByNamePostResponses, ToggleByNameKasaToggleByNamePostErrors, ThrowOnError>({
    url: '/kasa/toggle-by-name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Status
 *
 * Get status of a specific device with extended info.
 */
export const statusKasaStatusGet = <ThrowOnError extends boolean = false>(options: Options<StatusKasaStatusGetData, ThrowOnError>): RequestResult<StatusKasaStatusGetResponses, StatusKasaStatusGetErrors, ThrowOnError> => (options.client ?? client).get<StatusKasaStatusGetResponses, StatusKasaStatusGetErrors, ThrowOnError>({ url: '/kasa/status', ...options });

/**
 * Brightness
 *
 * Set brightness for dimmable devices (0-100).
 */
export const brightnessKasaBrightnessPost = <ThrowOnError extends boolean = false>(options: Options<BrightnessKasaBrightnessPostData, ThrowOnError>): RequestResult<BrightnessKasaBrightnessPostResponses, BrightnessKasaBrightnessPostErrors, ThrowOnError> => (options.client ?? client).post<BrightnessKasaBrightnessPostResponses, BrightnessKasaBrightnessPostErrors, ThrowOnError>({
    url: '/kasa/brightness',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Countdown
 *
 * Set countdown timer to turn device on/off after delay.
 */
export const countdownKasaCountdownPost = <ThrowOnError extends boolean = false>(options: Options<CountdownKasaCountdownPostData, ThrowOnError>): RequestResult<CountdownKasaCountdownPostResponses, CountdownKasaCountdownPostErrors, ThrowOnError> => (options.client ?? client).post<CountdownKasaCountdownPostResponses, CountdownKasaCountdownPostErrors, ThrowOnError>({
    url: '/kasa/countdown',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Schedule
 *
 * Delete a schedule rule.
 */
export const deleteScheduleKasaScheduleDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteScheduleKasaScheduleDeleteData, ThrowOnError>): RequestResult<DeleteScheduleKasaScheduleDeleteResponses, DeleteScheduleKasaScheduleDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteScheduleKasaScheduleDeleteResponses, DeleteScheduleKasaScheduleDeleteErrors, ThrowOnError>({
    url: '/kasa/schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Schedule
 *
 * Get schedule rules for a device.
 */
export const scheduleKasaScheduleGet = <ThrowOnError extends boolean = false>(options: Options<ScheduleKasaScheduleGetData, ThrowOnError>): RequestResult<ScheduleKasaScheduleGetResponses, ScheduleKasaScheduleGetErrors, ThrowOnError> => (options.client ?? client).get<ScheduleKasaScheduleGetResponses, ScheduleKasaScheduleGetErrors, ThrowOnError>({ url: '/kasa/schedule', ...options });

/**
 * Add Schedule
 *
 * Add a new schedule rule to a device.
 */
export const addScheduleKasaSchedulePost = <ThrowOnError extends boolean = false>(options: Options<AddScheduleKasaSchedulePostData, ThrowOnError>): RequestResult<AddScheduleKasaSchedulePostResponses, AddScheduleKasaSchedulePostErrors, ThrowOnError> => (options.client ?? client).post<AddScheduleKasaSchedulePostResponses, AddScheduleKasaSchedulePostErrors, ThrowOnError>({
    url: '/kasa/schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Schedule
 *
 * Update an existing schedule rule.
 */
export const updateScheduleKasaSchedulePut = <ThrowOnError extends boolean = false>(options: Options<UpdateScheduleKasaSchedulePutData, ThrowOnError>): RequestResult<UpdateScheduleKasaSchedulePutResponses, UpdateScheduleKasaSchedulePutErrors, ThrowOnError> => (options.client ?? client).put<UpdateScheduleKasaSchedulePutResponses, UpdateScheduleKasaSchedulePutErrors, ThrowOnError>({
    url: '/kasa/schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Devices
 *
 * List all Zigbee devices.
 */
export const listDevicesMqttDevicesGet = <ThrowOnError extends boolean = false>(options?: Options<ListDevicesMqttDevicesGetData, ThrowOnError>): RequestResult<ListDevicesMqttDevicesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDevicesMqttDevicesGetResponses, unknown, ThrowOnError>({ url: '/mqtt/devices', ...options });

/**
 * Get Bridge Info
 *
 * Get Zigbee2MQTT bridge information.
 */
export const getBridgeInfoMqttBridgeGet = <ThrowOnError extends boolean = false>(options?: Options<GetBridgeInfoMqttBridgeGetData, ThrowOnError>): RequestResult<GetBridgeInfoMqttBridgeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBridgeInfoMqttBridgeGetResponses, unknown, ThrowOnError>({ url: '/mqtt/bridge', ...options });

/**
 * Rename Device
 *
 * Rename a Zigbee device.
 */
export const renameDeviceMqttDevicesRenamePost = <ThrowOnError extends boolean = false>(options: Options<RenameDeviceMqttDevicesRenamePostData, ThrowOnError>): RequestResult<RenameDeviceMqttDevicesRenamePostResponses, RenameDeviceMqttDevicesRenamePostErrors, ThrowOnError> => (options.client ?? client).post<RenameDeviceMqttDevicesRenamePostResponses, RenameDeviceMqttDevicesRenamePostErrors, ThrowOnError>({
    url: '/mqtt/devices/rename',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Device
 *
 * Remove a Zigbee device from the network.
 */
export const removeDeviceMqttDevicesRemovePost = <ThrowOnError extends boolean = false>(options: Options<RemoveDeviceMqttDevicesRemovePostData, ThrowOnError>): RequestResult<RemoveDeviceMqttDevicesRemovePostResponses, RemoveDeviceMqttDevicesRemovePostErrors, ThrowOnError> => (options.client ?? client).post<RemoveDeviceMqttDevicesRemovePostResponses, RemoveDeviceMqttDevicesRemovePostErrors, ThrowOnError>({
    url: '/mqtt/devices/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Permit Join
 *
 * Enable or disable device pairing mode.
 */
export const setPermitJoinMqttPermitJoinPost = <ThrowOnError extends boolean = false>(options: Options<SetPermitJoinMqttPermitJoinPostData, ThrowOnError>): RequestResult<SetPermitJoinMqttPermitJoinPostResponses, SetPermitJoinMqttPermitJoinPostErrors, ThrowOnError> => (options.client ?? client).post<SetPermitJoinMqttPermitJoinPostResponses, SetPermitJoinMqttPermitJoinPostErrors, ThrowOnError>({
    url: '/mqtt/permit-join',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Custom Devices
 *
 * List custom (non-Zigbee) climate sensors.
 */
export const listCustomDevicesMqttCustomDevicesGet = <ThrowOnError extends boolean = false>(options?: Options<ListCustomDevicesMqttCustomDevicesGetData, ThrowOnError>): RequestResult<ListCustomDevicesMqttCustomDevicesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListCustomDevicesMqttCustomDevicesGetResponses, unknown, ThrowOnError>({ url: '/mqtt/custom-devices', ...options });

/**
 * Add Custom Device
 *
 * Add a custom (non-Zigbee) climate sensor.
 */
export const addCustomDeviceMqttCustomDevicesPost = <ThrowOnError extends boolean = false>(options: Options<AddCustomDeviceMqttCustomDevicesPostData, ThrowOnError>): RequestResult<AddCustomDeviceMqttCustomDevicesPostResponses, AddCustomDeviceMqttCustomDevicesPostErrors, ThrowOnError> => (options.client ?? client).post<AddCustomDeviceMqttCustomDevicesPostResponses, AddCustomDeviceMqttCustomDevicesPostErrors, ThrowOnError>({
    url: '/mqtt/custom-devices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Custom Device
 *
 * Remove a custom (non-Zigbee) climate sensor.
 */
export const removeCustomDeviceMqttCustomDevicesRemovePost = <ThrowOnError extends boolean = false>(options: Options<RemoveCustomDeviceMqttCustomDevicesRemovePostData, ThrowOnError>): RequestResult<RemoveCustomDeviceMqttCustomDevicesRemovePostResponses, RemoveCustomDeviceMqttCustomDevicesRemovePostErrors, ThrowOnError> => (options.client ?? client).post<RemoveCustomDeviceMqttCustomDevicesRemovePostResponses, RemoveCustomDeviceMqttCustomDevicesRemovePostErrors, ThrowOnError>({
    url: '/mqtt/custom-devices/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Command
 *
 * Receive voice command and broadcast to dashboard.
 *
 * Body: { "type": "add-to-list", "item": "cheese", "list": "groceries" }
 */
export const sendCommandVoiceCommandPost = <ThrowOnError extends boolean = false>(options: Options<SendCommandVoiceCommandPostData, ThrowOnError>): RequestResult<SendCommandVoiceCommandPostResponses, SendCommandVoiceCommandPostErrors, ThrowOnError> => (options.client ?? client).post<SendCommandVoiceCommandPostResponses, SendCommandVoiceCommandPostErrors, ThrowOnError>({
    url: '/voice/command',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Subscribe
 *
 * SSE endpoint for dashboard to receive voice commands.
 */
export const subscribeVoiceSubscribeGet = <ThrowOnError extends boolean = false>(options?: Options<SubscribeVoiceSubscribeGetData, ThrowOnError>): RequestResult<SubscribeVoiceSubscribeGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SubscribeVoiceSubscribeGetResponses, unknown, ThrowOnError>({ url: '/voice/subscribe', ...options });

/**
 * Transcribe
 *
 * Transcribe audio to text.
 *
 * Accepts raw PCM audio (16kHz, mono, 16-bit).
 * Returns: { "text": "transcribed text" }
 */
export const transcribeVoiceTranscribePost = <ThrowOnError extends boolean = false>(options?: Options<TranscribeVoiceTranscribePostData, ThrowOnError>): RequestResult<TranscribeVoiceTranscribePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<TranscribeVoiceTranscribePostResponses, unknown, ThrowOnError>({ url: '/voice/transcribe', ...options });

/**
 * Transcribe And Execute
 *
 * Transcribe audio and execute matching command.
 *
 * Accepts raw PCM audio (16kHz, mono, 16-bit).
 * Returns: { "text": "...", "command": "...", "result": {...} }
 */
export const transcribeAndExecuteVoiceTranscribeAndExecutePost = <ThrowOnError extends boolean = false>(options?: Options<TranscribeAndExecuteVoiceTranscribeAndExecutePostData, ThrowOnError>): RequestResult<TranscribeAndExecuteVoiceTranscribeAndExecutePostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<TranscribeAndExecuteVoiceTranscribeAndExecutePostResponses, unknown, ThrowOnError>({ url: '/voice/transcribe-and-execute', ...options });

/**
 * List Models
 *
 * List all available models with download status.
 */
export const listModelsVoiceModelsGet = <ThrowOnError extends boolean = false>(options?: Options<ListModelsVoiceModelsGetData, ThrowOnError>): RequestResult<ListModelsVoiceModelsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListModelsVoiceModelsGetResponses, unknown, ThrowOnError>({ url: '/voice/models', ...options });

/**
 * Delete Model
 *
 * Delete a downloaded model.
 */
export const deleteModelVoiceModelsModelIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteModelVoiceModelsModelIdDeleteData, ThrowOnError>): RequestResult<DeleteModelVoiceModelsModelIdDeleteResponses, DeleteModelVoiceModelsModelIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteModelVoiceModelsModelIdDeleteResponses, DeleteModelVoiceModelsModelIdDeleteErrors, ThrowOnError>({ url: '/voice/models/{model_id}', ...options });

/**
 * Get Model
 *
 * Get info for a specific model.
 */
export const getModelVoiceModelsModelIdGet = <ThrowOnError extends boolean = false>(options: Options<GetModelVoiceModelsModelIdGetData, ThrowOnError>): RequestResult<GetModelVoiceModelsModelIdGetResponses, GetModelVoiceModelsModelIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetModelVoiceModelsModelIdGetResponses, GetModelVoiceModelsModelIdGetErrors, ThrowOnError>({ url: '/voice/models/{model_id}', ...options });

/**
 * Download Model
 *
 * Start downloading a model. Returns SSE stream with progress updates.
 */
export const downloadModelVoiceModelsModelIdDownloadPost = <ThrowOnError extends boolean = false>(options: Options<DownloadModelVoiceModelsModelIdDownloadPostData, ThrowOnError>): RequestResult<DownloadModelVoiceModelsModelIdDownloadPostResponses, DownloadModelVoiceModelsModelIdDownloadPostErrors, ThrowOnError> => (options.client ?? client).post<DownloadModelVoiceModelsModelIdDownloadPostResponses, DownloadModelVoiceModelsModelIdDownloadPostErrors, ThrowOnError>({ url: '/voice/models/{model_id}/download', ...options });

/**
 * Tts Status
 *
 * Get TTS status - is Piper installed, what voice is selected.
 */
export const ttsStatusVoiceTtsStatusGet = <ThrowOnError extends boolean = false>(options?: Options<TtsStatusVoiceTtsStatusGetData, ThrowOnError>): RequestResult<TtsStatusVoiceTtsStatusGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TtsStatusVoiceTtsStatusGetResponses, unknown, ThrowOnError>({ url: '/voice/tts/status', ...options });

/**
 * List Voices
 *
 * List all available voices with download status.
 */
export const listVoicesVoiceTtsVoicesGet = <ThrowOnError extends boolean = false>(options?: Options<ListVoicesVoiceTtsVoicesGetData, ThrowOnError>): RequestResult<ListVoicesVoiceTtsVoicesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListVoicesVoiceTtsVoicesGetResponses, unknown, ThrowOnError>({ url: '/voice/tts/voices', ...options });

/**
 * Delete Voice
 *
 * Delete a downloaded voice.
 */
export const deleteVoiceVoiceTtsVoicesVoiceIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteVoiceVoiceTtsVoicesVoiceIdDeleteData, ThrowOnError>): RequestResult<DeleteVoiceVoiceTtsVoicesVoiceIdDeleteResponses, DeleteVoiceVoiceTtsVoicesVoiceIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteVoiceVoiceTtsVoicesVoiceIdDeleteResponses, DeleteVoiceVoiceTtsVoicesVoiceIdDeleteErrors, ThrowOnError>({ url: '/voice/tts/voices/{voice_id}', ...options });

/**
 * Get Voice
 *
 * Get info for a specific voice.
 */
export const getVoiceVoiceTtsVoicesVoiceIdGet = <ThrowOnError extends boolean = false>(options: Options<GetVoiceVoiceTtsVoicesVoiceIdGetData, ThrowOnError>): RequestResult<GetVoiceVoiceTtsVoicesVoiceIdGetResponses, GetVoiceVoiceTtsVoicesVoiceIdGetErrors, ThrowOnError> => (options.client ?? client).get<GetVoiceVoiceTtsVoicesVoiceIdGetResponses, GetVoiceVoiceTtsVoicesVoiceIdGetErrors, ThrowOnError>({ url: '/voice/tts/voices/{voice_id}', ...options });

/**
 * Download Voice
 *
 * Start downloading a voice. Returns SSE stream with progress updates.
 */
export const downloadVoiceVoiceTtsVoicesVoiceIdDownloadPost = <ThrowOnError extends boolean = false>(options: Options<DownloadVoiceVoiceTtsVoicesVoiceIdDownloadPostData, ThrowOnError>): RequestResult<DownloadVoiceVoiceTtsVoicesVoiceIdDownloadPostResponses, DownloadVoiceVoiceTtsVoicesVoiceIdDownloadPostErrors, ThrowOnError> => (options.client ?? client).post<DownloadVoiceVoiceTtsVoicesVoiceIdDownloadPostResponses, DownloadVoiceVoiceTtsVoicesVoiceIdDownloadPostErrors, ThrowOnError>({ url: '/voice/tts/voices/{voice_id}/download', ...options });

/**
 * Speak Endpoint
 *
 * Speak text using TTS.
 */
export const speakEndpointVoiceTtsSpeakPost = <ThrowOnError extends boolean = false>(options: Options<SpeakEndpointVoiceTtsSpeakPostData, ThrowOnError>): RequestResult<SpeakEndpointVoiceTtsSpeakPostResponses, SpeakEndpointVoiceTtsSpeakPostErrors, ThrowOnError> => (options.client ?? client).post<SpeakEndpointVoiceTtsSpeakPostResponses, SpeakEndpointVoiceTtsSpeakPostErrors, ThrowOnError>({
    url: '/voice/tts/speak',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Status
 *
 * Get AdGuard Home protection status.
 */
export const getStatusAdguardStatusPost = <ThrowOnError extends boolean = false>(options: Options<GetStatusAdguardStatusPostData, ThrowOnError>): RequestResult<GetStatusAdguardStatusPostResponses, GetStatusAdguardStatusPostErrors, ThrowOnError> => (options.client ?? client).post<GetStatusAdguardStatusPostResponses, GetStatusAdguardStatusPostErrors, ThrowOnError>({
    url: '/adguard/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Protection
 *
 * Enable or disable AdGuard protection.
 */
export const setProtectionAdguardProtectionPost = <ThrowOnError extends boolean = false>(options: Options<SetProtectionAdguardProtectionPostData, ThrowOnError>): RequestResult<SetProtectionAdguardProtectionPostResponses, SetProtectionAdguardProtectionPostErrors, ThrowOnError> => (options.client ?? client).post<SetProtectionAdguardProtectionPostResponses, SetProtectionAdguardProtectionPostErrors, ThrowOnError>({
    url: '/adguard/protection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Version
 *
 * Check for AdGuard Home updates.
 */
export const getVersionAdguardVersionPost = <ThrowOnError extends boolean = false>(options: Options<GetVersionAdguardVersionPostData, ThrowOnError>): RequestResult<GetVersionAdguardVersionPostResponses, GetVersionAdguardVersionPostErrors, ThrowOnError> => (options.client ?? client).post<GetVersionAdguardVersionPostResponses, GetVersionAdguardVersionPostErrors, ThrowOnError>({
    url: '/adguard/version',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Events
 *
 * List all notification events.
 */
export const listEventsNotificationsGet = <ThrowOnError extends boolean = false>(options?: Options<ListEventsNotificationsGetData, ThrowOnError>): RequestResult<ListEventsNotificationsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListEventsNotificationsGetResponses, unknown, ThrowOnError>({ url: '/notifications', ...options });

/**
 * Add Event
 *
 * Add or update a notification event.
 *
 * Called by iframed apps (health-tracker, maintenance-tracker, etc.)
 * to register upcoming due dates for the dashboard to track.
 */
export const addEventNotificationsPost = <ThrowOnError extends boolean = false>(options: Options<AddEventNotificationsPostData, ThrowOnError>): RequestResult<AddEventNotificationsPostResponses, AddEventNotificationsPostErrors, ThrowOnError> => (options.client ?? client).post<AddEventNotificationsPostResponses, AddEventNotificationsPostErrors, ThrowOnError>({
    url: '/notifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Due
 *
 * Get currently due notifications (for initial load).
 */
export const getDueNotificationsDueGet = <ThrowOnError extends boolean = false>(options?: Options<GetDueNotificationsDueGetData, ThrowOnError>): RequestResult<GetDueNotificationsDueGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDueNotificationsDueGetResponses, unknown, ThrowOnError>({ url: '/notifications/due', ...options });

/**
 * Delete Event
 *
 * Delete a notification event.
 */
export const deleteEventNotificationsEventIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteEventNotificationsEventIdDeleteData, ThrowOnError>): RequestResult<DeleteEventNotificationsEventIdDeleteResponses, DeleteEventNotificationsEventIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEventNotificationsEventIdDeleteResponses, DeleteEventNotificationsEventIdDeleteErrors, ThrowOnError>({ url: '/notifications/{event_id}', ...options });

/**
 * Dismiss Event
 *
 * Dismiss a notification for a specified number of hours, until midnight, or permanently.
 */
export const dismissEventNotificationsEventIdDismissPost = <ThrowOnError extends boolean = false>(options: Options<DismissEventNotificationsEventIdDismissPostData, ThrowOnError>): RequestResult<DismissEventNotificationsEventIdDismissPostResponses, DismissEventNotificationsEventIdDismissPostErrors, ThrowOnError> => (options.client ?? client).post<DismissEventNotificationsEventIdDismissPostResponses, DismissEventNotificationsEventIdDismissPostErrors, ThrowOnError>({
    url: '/notifications/{event_id}/dismiss',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Undismiss Event
 *
 * Clear dismissal for an event, making it due again.
 */
export const undismissEventNotificationsEventIdUndismissPost = <ThrowOnError extends boolean = false>(options: Options<UndismissEventNotificationsEventIdUndismissPostData, ThrowOnError>): RequestResult<UndismissEventNotificationsEventIdUndismissPostResponses, UndismissEventNotificationsEventIdUndismissPostErrors, ThrowOnError> => (options.client ?? client).post<UndismissEventNotificationsEventIdUndismissPostResponses, UndismissEventNotificationsEventIdUndismissPostErrors, ThrowOnError>({ url: '/notifications/{event_id}/undismiss', ...options });

/**
 * Trigger Check
 *
 * Manually trigger notification check (for testing).
 */
export const triggerCheckNotificationsCheckPost = <ThrowOnError extends boolean = false>(options?: Options<TriggerCheckNotificationsCheckPostData, ThrowOnError>): RequestResult<TriggerCheckNotificationsCheckPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<TriggerCheckNotificationsCheckPostResponses, unknown, ThrowOnError>({ url: '/notifications/check', ...options });

/**
 * Get Preferences
 *
 * Get notification type preferences (which types are enabled/disabled).
 */
export const getPreferencesNotificationsPreferencesGet = <ThrowOnError extends boolean = false>(options?: Options<GetPreferencesNotificationsPreferencesGetData, ThrowOnError>): RequestResult<GetPreferencesNotificationsPreferencesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPreferencesNotificationsPreferencesGetResponses, unknown, ThrowOnError>({ url: '/notifications/preferences', ...options });

/**
 * Delete Preference
 *
 * Delete a notification type and all its events.
 *
 * When deleted, if a new notification of this type comes in later,
 * it will be re-added as a new unconfigured type.
 */
export const deletePreferenceNotificationsPreferencesEventTypeDelete = <ThrowOnError extends boolean = false>(options: Options<DeletePreferenceNotificationsPreferencesEventTypeDeleteData, ThrowOnError>): RequestResult<DeletePreferenceNotificationsPreferencesEventTypeDeleteResponses, DeletePreferenceNotificationsPreferencesEventTypeDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeletePreferenceNotificationsPreferencesEventTypeDeleteResponses, DeletePreferenceNotificationsPreferencesEventTypeDeleteErrors, ThrowOnError>({ url: '/notifications/preferences/{event_type}', ...options });

/**
 * Set Preference
 *
 * Enable or disable notifications for a type.
 */
export const setPreferenceNotificationsPreferencesEventTypePost = <ThrowOnError extends boolean = false>(options: Options<SetPreferenceNotificationsPreferencesEventTypePostData, ThrowOnError>): RequestResult<SetPreferenceNotificationsPreferencesEventTypePostResponses, SetPreferenceNotificationsPreferencesEventTypePostErrors, ThrowOnError> => (options.client ?? client).post<SetPreferenceNotificationsPreferencesEventTypePostResponses, SetPreferenceNotificationsPreferencesEventTypePostErrors, ThrowOnError>({ url: '/notifications/preferences/{event_type}', ...options });

/**
 * Get System Stats
 *
 * Get current system stats (CPU, memory, disk, uptime).
 */
export const getSystemStatsSystemStatsGet = <ThrowOnError extends boolean = false>(options?: Options<GetSystemStatsSystemStatsGetData, ThrowOnError>): RequestResult<GetSystemStatsSystemStatsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSystemStatsSystemStatsGetResponses, unknown, ThrowOnError>({ url: '/system/stats', ...options });

/**
 * Unlink
 *
 * Remove the SimpleFIN link and all cached transactions.
 */
export const unlinkMoneyLinkDelete = <ThrowOnError extends boolean = false>(options?: Options<UnlinkMoneyLinkDeleteData, ThrowOnError>): RequestResult<UnlinkMoneyLinkDeleteResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<UnlinkMoneyLinkDeleteResponses, unknown, ThrowOnError>({ url: '/money/link', ...options });

/**
 * Link Accounts
 *
 * Claim a SimpleFIN access URL from a setup token and link accounts.
 */
export const linkAccountsMoneyLinkPost = <ThrowOnError extends boolean = false>(options: Options<LinkAccountsMoneyLinkPostData, ThrowOnError>): RequestResult<LinkAccountsMoneyLinkPostResponses, LinkAccountsMoneyLinkPostErrors, ThrowOnError> => (options.client ?? client).post<LinkAccountsMoneyLinkPostResponses, LinkAccountsMoneyLinkPostErrors, ThrowOnError>({
    url: '/money/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Summary
 *
 * Get spend vs. ghost pace vs. budget for a month (defaults to current).
 */
export const getSummaryMoneySummaryGet = <ThrowOnError extends boolean = false>(options?: Options<GetSummaryMoneySummaryGetData, ThrowOnError>): RequestResult<GetSummaryMoneySummaryGetResponses, GetSummaryMoneySummaryGetErrors, ThrowOnError> => (options?.client ?? client).get<GetSummaryMoneySummaryGetResponses, GetSummaryMoneySummaryGetErrors, ThrowOnError>({ url: '/money/summary', ...options });

/**
 * Get Settings
 *
 * Get current money-tracker settings.
 */
export const getSettingsMoneySettingsGet = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsMoneySettingsGetData, ThrowOnError>): RequestResult<GetSettingsMoneySettingsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSettingsMoneySettingsGetResponses, unknown, ThrowOnError>({ url: '/money/settings', ...options });

/**
 * Get Transactions
 *
 * Get recent cached transactions.
 */
export const getTransactionsMoneyTransactionsGet = <ThrowOnError extends boolean = false>(options?: Options<GetTransactionsMoneyTransactionsGetData, ThrowOnError>): RequestResult<GetTransactionsMoneyTransactionsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetTransactionsMoneyTransactionsGetResponses, unknown, ThrowOnError>({ url: '/money/transactions', ...options });

/**
 * Set Transaction Excluded
 *
 * Manually mark a transaction as excluded (or included) from spend totals.
 */
export const setTransactionExcludedMoneyTransactionsTransactionIdExcludePost = <ThrowOnError extends boolean = false>(options: Options<SetTransactionExcludedMoneyTransactionsTransactionIdExcludePostData, ThrowOnError>): RequestResult<SetTransactionExcludedMoneyTransactionsTransactionIdExcludePostResponses, SetTransactionExcludedMoneyTransactionsTransactionIdExcludePostErrors, ThrowOnError> => (options.client ?? client).post<SetTransactionExcludedMoneyTransactionsTransactionIdExcludePostResponses, SetTransactionExcludedMoneyTransactionsTransactionIdExcludePostErrors, ThrowOnError>({
    url: '/money/transactions/{transaction_id}/exclude',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Default Budget
 *
 * Set the default monthly budget.
 */
export const setDefaultBudgetMoneyBudgetPost = <ThrowOnError extends boolean = false>(options: Options<SetDefaultBudgetMoneyBudgetPostData, ThrowOnError>): RequestResult<SetDefaultBudgetMoneyBudgetPostResponses, SetDefaultBudgetMoneyBudgetPostErrors, ThrowOnError> => (options.client ?? client).post<SetDefaultBudgetMoneyBudgetPostResponses, SetDefaultBudgetMoneyBudgetPostErrors, ThrowOnError>({
    url: '/money/budget',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Monthly Override
 *
 * Set a one-off budget override for a specific month.
 */
export const setMonthlyOverrideMoneyBudgetOverridePost = <ThrowOnError extends boolean = false>(options: Options<SetMonthlyOverrideMoneyBudgetOverridePostData, ThrowOnError>): RequestResult<SetMonthlyOverrideMoneyBudgetOverridePostResponses, SetMonthlyOverrideMoneyBudgetOverridePostErrors, ThrowOnError> => (options.client ?? client).post<SetMonthlyOverrideMoneyBudgetOverridePostResponses, SetMonthlyOverrideMoneyBudgetOverridePostErrors, ThrowOnError>({
    url: '/money/budget/override',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Monthly Override
 *
 * Clear a budget override, reverting that month to the default.
 */
export const clearMonthlyOverrideMoneyBudgetOverrideMonthDelete = <ThrowOnError extends boolean = false>(options: Options<ClearMonthlyOverrideMoneyBudgetOverrideMonthDeleteData, ThrowOnError>): RequestResult<ClearMonthlyOverrideMoneyBudgetOverrideMonthDeleteResponses, ClearMonthlyOverrideMoneyBudgetOverrideMonthDeleteErrors, ThrowOnError> => (options.client ?? client).delete<ClearMonthlyOverrideMoneyBudgetOverrideMonthDeleteResponses, ClearMonthlyOverrideMoneyBudgetOverrideMonthDeleteErrors, ThrowOnError>({ url: '/money/budget/override/{month}', ...options });

/**
 * Set Deposit Settings
 *
 * Configure paycheck-matching strings and the large-deposit alert threshold.
 */
export const setDepositSettingsMoneySettingsDepositsPost = <ThrowOnError extends boolean = false>(options: Options<SetDepositSettingsMoneySettingsDepositsPostData, ThrowOnError>): RequestResult<SetDepositSettingsMoneySettingsDepositsPostResponses, SetDepositSettingsMoneySettingsDepositsPostErrors, ThrowOnError> => (options.client ?? client).post<SetDepositSettingsMoneySettingsDepositsPostResponses, SetDepositSettingsMoneySettingsDepositsPostErrors, ThrowOnError>({
    url: '/money/settings/deposits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Transfer Keywords
 *
 * Configure transfer/payment keyword matching.
 */
export const setTransferKeywordsMoneySettingsTransfersPost = <ThrowOnError extends boolean = false>(options: Options<SetTransferKeywordsMoneySettingsTransfersPostData, ThrowOnError>): RequestResult<SetTransferKeywordsMoneySettingsTransfersPostResponses, SetTransferKeywordsMoneySettingsTransfersPostErrors, ThrowOnError> => (options.client ?? client).post<SetTransferKeywordsMoneySettingsTransfersPostResponses, SetTransferKeywordsMoneySettingsTransfersPostErrors, ThrowOnError>({
    url: '/money/settings/transfers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync Now
 *
 * Manually trigger a SimpleFIN transaction sync (rate-limited to once per 2 hours).
 */
export const syncNowMoneySyncPost = <ThrowOnError extends boolean = false>(options?: Options<SyncNowMoneySyncPostData, ThrowOnError>): RequestResult<SyncNowMoneySyncPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SyncNowMoneySyncPostResponses, unknown, ThrowOnError>({ url: '/money/sync', ...options });

/**
 * Live
 *
 * Get the most recent poll's nearby aircraft.
 */
export const livePlanesLiveGet = <ThrowOnError extends boolean = false>(options?: Options<LivePlanesLiveGetData, ThrowOnError>): RequestResult<LivePlanesLiveGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LivePlanesLiveGetResponses, unknown, ThrowOnError>({ url: '/planes/live', ...options });

/**
 * Get Settings
 *
 * Get current plane-tracker settings.
 */
export const getSettingsPlanesSettingsGet = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsPlanesSettingsGetData, ThrowOnError>): RequestResult<GetSettingsPlanesSettingsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSettingsPlanesSettingsGetResponses, unknown, ThrowOnError>({ url: '/planes/settings', ...options });

/**
 * Update Settings
 *
 * Update global plane-tracker settings (geofence, poll interval, ntfy).
 */
export const updateSettingsPlanesSettingsPut = <ThrowOnError extends boolean = false>(options: Options<UpdateSettingsPlanesSettingsPutData, ThrowOnError>): RequestResult<UpdateSettingsPlanesSettingsPutResponses, UpdateSettingsPlanesSettingsPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateSettingsPlanesSettingsPutResponses, UpdateSettingsPlanesSettingsPutErrors, ThrowOnError>({
    url: '/planes/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Location Profiles
 *
 * List named locations and indicate the active one.
 */
export const listLocationProfilesPlanesLocationProfilesGet = <ThrowOnError extends boolean = false>(options?: Options<ListLocationProfilesPlanesLocationProfilesGetData, ThrowOnError>): RequestResult<ListLocationProfilesPlanesLocationProfilesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListLocationProfilesPlanesLocationProfilesGetResponses, unknown, ThrowOnError>({ url: '/planes/location-profiles', ...options });

/**
 * Add Location Profile
 *
 * Create a named location and make it active.
 */
export const addLocationProfilePlanesLocationProfilesPost = <ThrowOnError extends boolean = false>(options: Options<AddLocationProfilePlanesLocationProfilesPostData, ThrowOnError>): RequestResult<AddLocationProfilePlanesLocationProfilesPostResponses, AddLocationProfilePlanesLocationProfilesPostErrors, ThrowOnError> => (options.client ?? client).post<AddLocationProfilePlanesLocationProfilesPostResponses, AddLocationProfilePlanesLocationProfilesPostErrors, ThrowOnError>({
    url: '/planes/location-profiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Location Profile
 *
 * Delete a named location profile.
 */
export const deleteLocationProfilePlanesLocationProfilesProfileIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteLocationProfilePlanesLocationProfilesProfileIdDeleteData, ThrowOnError>): RequestResult<DeleteLocationProfilePlanesLocationProfilesProfileIdDeleteResponses, DeleteLocationProfilePlanesLocationProfilesProfileIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLocationProfilePlanesLocationProfilesProfileIdDeleteResponses, DeleteLocationProfilePlanesLocationProfilesProfileIdDeleteErrors, ThrowOnError>({ url: '/planes/location-profiles/{profile_id}', ...options });

/**
 * Update Location Profile
 *
 * Update a location profile's name or coordinates.
 */
export const updateLocationProfilePlanesLocationProfilesProfileIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateLocationProfilePlanesLocationProfilesProfileIdPutData, ThrowOnError>): RequestResult<UpdateLocationProfilePlanesLocationProfilesProfileIdPutResponses, UpdateLocationProfilePlanesLocationProfilesProfileIdPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateLocationProfilePlanesLocationProfilesProfileIdPutResponses, UpdateLocationProfilePlanesLocationProfilesProfileIdPutErrors, ThrowOnError>({
    url: '/planes/location-profiles/{profile_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate Location Profile
 *
 * Make a location profile the single active plane-tracker location.
 */
export const activateLocationProfilePlanesLocationProfilesProfileIdActivePut = <ThrowOnError extends boolean = false>(options: Options<ActivateLocationProfilePlanesLocationProfilesProfileIdActivePutData, ThrowOnError>): RequestResult<ActivateLocationProfilePlanesLocationProfilesProfileIdActivePutResponses, ActivateLocationProfilePlanesLocationProfilesProfileIdActivePutErrors, ThrowOnError> => (options.client ?? client).put<ActivateLocationProfilePlanesLocationProfilesProfileIdActivePutResponses, ActivateLocationProfilePlanesLocationProfilesProfileIdActivePutErrors, ThrowOnError>({ url: '/planes/location-profiles/{profile_id}/active', ...options });

/**
 * List Watchlist
 *
 * List watch-list entries.
 */
export const listWatchlistPlanesWatchlistGet = <ThrowOnError extends boolean = false>(options?: Options<ListWatchlistPlanesWatchlistGetData, ThrowOnError>): RequestResult<ListWatchlistPlanesWatchlistGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWatchlistPlanesWatchlistGetResponses, unknown, ThrowOnError>({ url: '/planes/watchlist', ...options });

/**
 * Add Watchlist Entry
 *
 * Add a watch-list entry (by ICAO hex, callsign prefix, aircraft model, or unresolved).
 */
export const addWatchlistEntryPlanesWatchlistPost = <ThrowOnError extends boolean = false>(options: Options<AddWatchlistEntryPlanesWatchlistPostData, ThrowOnError>): RequestResult<AddWatchlistEntryPlanesWatchlistPostResponses, AddWatchlistEntryPlanesWatchlistPostErrors, ThrowOnError> => (options.client ?? client).post<AddWatchlistEntryPlanesWatchlistPostResponses, AddWatchlistEntryPlanesWatchlistPostErrors, ThrowOnError>({
    url: '/planes/watchlist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Watchlist Entry
 *
 * Remove a watch-list entry.
 */
export const deleteWatchlistEntryPlanesWatchlistEntryIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteWatchlistEntryPlanesWatchlistEntryIdDeleteData, ThrowOnError>): RequestResult<DeleteWatchlistEntryPlanesWatchlistEntryIdDeleteResponses, DeleteWatchlistEntryPlanesWatchlistEntryIdDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWatchlistEntryPlanesWatchlistEntryIdDeleteResponses, DeleteWatchlistEntryPlanesWatchlistEntryIdDeleteErrors, ThrowOnError>({ url: '/planes/watchlist/{entry_id}', ...options });

/**
 * Update Watchlist Entry
 *
 * Update an existing watch-list filter.
 */
export const updateWatchlistEntryPlanesWatchlistEntryIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateWatchlistEntryPlanesWatchlistEntryIdPutData, ThrowOnError>): RequestResult<UpdateWatchlistEntryPlanesWatchlistEntryIdPutResponses, UpdateWatchlistEntryPlanesWatchlistEntryIdPutErrors, ThrowOnError> => (options.client ?? client).put<UpdateWatchlistEntryPlanesWatchlistEntryIdPutResponses, UpdateWatchlistEntryPlanesWatchlistEntryIdPutErrors, ThrowOnError>({
    url: '/planes/watchlist/{entry_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
